export default class VideoEmbed {
    private readonly selector = ".video-block-player";

    constructor() {
        this.init();
    }

    private init(): void {
        const videoBlocks =
            document.querySelectorAll<HTMLDivElement>(this.selector);

        videoBlocks.forEach((videoBlock) => {
            const playButton =
                videoBlock.querySelector<HTMLButtonElement>("button");
            const videoUrl = videoBlock.dataset.url;

            if (!playButton || !videoUrl) {
                playButton?.setAttribute("disabled", "disabled");
                return;
            }

            playButton.addEventListener(
                "click",
                () => this.loadVideo(videoBlock, videoUrl),
                { once: true },
            );
        });
    }

    private loadVideo(videoBlock: HTMLDivElement, videoUrl: string): void {
        const iframe = this.createIframe(
            videoUrl,
            videoBlock.dataset.title || "Video",
        );

        videoBlock.classList.add("video-block-player--is-playing");
        videoBlock.appendChild(iframe);
    }

    private createIframe(url: string, title: string): HTMLIFrameElement {
        const iframe = document.createElement("iframe");
        const glueChar = url.includes("?") ? "&" : "?";

        iframe.src = `${url}${glueChar}autoplay=1`;
        iframe.title = title;
        iframe.allow =
            "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share";
        iframe.allowFullscreen = true;
        iframe.setAttribute("frameborder", "0");

        return iframe;
    }
}
